<template>
  <v-layout row justify-space-between class="pl-4 pr-4 pt-5 pb-2">
    <div style="display: flex; flex-direction: column;">
      <div>......................................</div>
      <div style="text-align: center;">Date</div>
    </div>
    <div style="display: flex; text-align: right; flex-direction: column;">
      <div>......................................</div>
      <div style="text-align: center;">Signature</div>
    </div>
  </v-layout>
</template>

<script>
export default {};
</script>

<style></style>
